var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentMethod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{mix-blend-mode:multiply;opacity:0.6;}.cls-3{fill:#1e5b87;}.cls-4,.cls-6{fill:#fff;}.cls-4,.cls-7{stroke:#1e5b87;stroke-miterlimit:10;}.cls-5,.cls-7{fill:#a7a9d1;}.cls-7{stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-2",
    width: 129,
    height: 129,
    transform: "translate(-1 3)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIEAAACBCAYAAADnoNlQAAAACXBIWXMAAAsSAAALEgHS3X78AAAQI0lEQVR4Xu2d63bbRhKEi7LWshxbduIkm/d/ut1N7Ei+yFJ04f4AilMo9OBCAiRIT50zB9QNFNHfVPcMBsBqvV6j6MfWed8vHLNWq9Wq73eGan3CvWV1Cp/Ngu2BnwIEP0ibr08BjqOEIBP0lTTY6ym0Rgr+Ovi6enGEB/Ro0kEQeG9ntuVr/v62YlCfkQL/bNtN03/zWIBYNAQ9gT+T9iKzVSB0P33S4GngnwE8ZbZsRwfEIiGQ4OcC/0Laeabx5+oI3GefNGAM7FPdHjPtSVoWiCXCsCgIMsHXnq1B/lfdXsr2pXyfv6duMAQASm3+GSnYD3X7p24Psn1AEwx1isXCsAgIguB7j2fQX0q7sPaq3ioMdASCAAwDQQs+BpIAMPj3AO7qrbZ/0AREXWLjEEuC4aAQ9ARfe7sG+hWAS9leytcE4QIxBEMAoNQFFAIG+65u36XdyVYBUZdYHAwHg6AGQFvU6y+Qgvy6ozkIczuBA3Db0fg7dAl3h02aOBQIe4fAer/3fFo5e/lrAD/V7Y00fk8hUCegg2hxuK0TaFHIHu1OwIB/q9tXafwegbhDShcNZziUK+wVAuv9bvu0+0ukIL+t25W8Vgg0HWg9oCOEbVIBFaWERzTrAk0HCsGXun2W1/w5YWCqUBj27gp7g0AAYO9X23+F1Os18FcA3qENAR1A7d9TgA4Px6QCylOCDxO1SKQr0BEcgpt660DcIjkDYdi4wr5AmB0Csf/I+i/QDD6D/g7Ae3l9hZQK1P5zwdfZQ2B3CIDmLGEXDEwPTAeE4AbAdb19jQQEYWDNsHGF1Wr1DMyfHmaFILB/tX7m/LdIwf65bu+RIKAD0P51KOgTQ9Es4ZjA56RAEASHgWmC9cIVqgAT7Jv69TWaMN+gOiasGTRFAHtID7NBkLF/tf43qA7Ke1SB/0W2CoAeMAZfiz4N/LbWP1SeIs7RBOIVkjPcIxW0b61pYUuoPyMBfYfq/99LepgFAgPgBVLuZ9HH3v8zgA+oAs+tAqC9Pxr25Xr9HAAA1X7XaL6nu4MOb6NRjjYvav3zsVYAZgRhcghqADT/0/699zPwv9bbD0gAaO/Xin+qfL+L9P3Wsj1DBUE0w6mTXNH8Bie4HITbev8PkDphahAmhcAA4IGg/bP3a/AdABaAtEkd78+V73eRA/ECCQgfAvtU96ugaa3jn3lTJ0wNwmQQBACwB/yE1Ps1+L/VW6aAKySL1GnfJQY/kv5Pmg4Vhi4g+s57cP+TgzAJBB0AvEHK/Qw8GwHgEFDtX3v/0oPv6oPBgfATYzkIVJOCsDMEVgQqAGr/vwL4XZoC8BZN+48+/DEE3xXBoMcqgoGtq/ilHjHR8HEnCDKjAHWAD6h6/e8A/l03BYD53+1fD9ixSz+DFrU5d2BzCID2fMUaE4watoagA4CfkBzgN1SB/6Pe/oYmAMz//qGB0wBA5a52jjhVRPMfQDPw2oAdQdgaglr8EDoMvEKqAX5HBcAfqAD4gCYA0dDv1IKv4mdzt3N38GOh8xDaIiBGaysIMoUgh4HvkQBgCiAA7xEDcEr2P0RdMPhxcAB8lRJh2LpQHA1BphC8RL4OUADeognAKdt/nzw99EHg5ykUhjV2KBRHQdBTB1whjQQIgReBEQA/WvBV6ghAMx6bwg/N4PuC1sZCVmxRH4yCoJa6AOsApgFOBvk8QAGgWzymQIpJBIGetvalal4nDNZgCAakAXWBAsB4OQh9EERrFjcQjHGDQRBk0oCPBnRKuACwnSIQIgh0ubu6goIwOC0MgqCWu0CUBng6WGcCfR6gANAtBWGN6vgRBF/trNc7hI6AAeqFQFxghXhSiAtB/GygA1CCP0483gRB3YBOoNc7tJanoQ5fnxv0QlCL/5AXg3pq2AHguYAfZSJoSumoQTteDoJoadpgN+iEIKgF/PQw1wRGp4OjcwFFw6UgnKMK6iWqABMCvdbBQRi8hH2IE0QjAl0epkvCSiE4rbxQ1BHZPdoXvGRBQIeyEPRMDBECXRXsZwRLHTCdtB5jOr5Hddy/IV3fwCueeC3DJi10ucEZuhW5gK4U0kWhpQ6YR7nOqHUZY6HpWN24MwYhBJkRgRaEepGIrgoudcA8UhDOUR1nX7nNFVo6NFdHXtVxbanLCZy+6E15XYAuC+slr2hrMSZcksb6wGOinbJ3fqYPAh0Waipg0zTwEiUNzClPCxypqTuz6YLd3nmaFgSWCkidXjfAq2h4dfCo/FO0s3J1msdGU8KmY0YpIecE/kZ66Zi+kS4PLy4wv6IikS4dQUCH7uyg20DANvhNiibXpPFpQBCMCtRyXqN5IaW7gP5t0XzyGKkbRDFqLePzlBA5QWQ3JM2vptVisKvILJpePOZeJHqMonTd2pErl3NeI9GlNsOd82+L5hePM+OkacFjNRoCLTy44z4ISjF4GEWxykHQGasNBJIntB5QJ9DGiaHeiYiiWeWuzfpNm17dtZkv0LogcgLmGqWLhOnVsz4JUUDYr6JOS+fWeLlrtzptLh1EO9UdqgsUJzictNOqG2i8ok6bhUBzDJ2AOyUIvsMCwOGlKcE7LuOlJ/ZadUFudKA1AXeqO3MACgiHkR5/BaErbq1YdY0OdIfa3FYKAIeVxqEvZvnRgY0MNMecW3uBBEDkIkWHEwPMGEWxa9RwjLvXBPpaHUEbd+R/U3Q4MQ7agT1m7gC9NQEBUGfQHZU0sDx5bDxuYSoA+i3dd1yCv3xF8coCAAyDILctMCxLGpNRnTYHge9Qt0XLV87BQzD6nKDo+KQBHuQGBYLT1GAXAAoEp6aoLvDXLRUITl9R8BtQFAhOU6OK+ALBaar3ngSqAsFpK3eTisb3CwSnJQ2ubjvvWJKDILezouPQuqc11OcEORAG3Qun6CDSYD/bNozZEAh6SSpahDxGEQBhDCMIop34LVMLDMuUxo73Poxi15BCoD/UnT1Z4079b4oOpyj4Ucw8xgBqCOSGRr6jR2vcKX+vaDlikP2W+H439A0MjLunA3cAvbW63mKdIJS0cHhpHPpiFhaIuZoguqFy7o7aQAHhUHIHHxK33ppA00HXXbUjEIoOIwcgipfe6rblBrl0EO2QzW+rXkA4nLyG87ugRx23Nx24E+gOc3fTLinhMNLjHnVaxsvvbtrqtBsIbISgueUe6W7abNFDFor2L00FdAGPlT8LYQ004t05OlCyeDt13kC5de9cFBD2rShWdACNlTr3qNGB0tUHAd2Af1s0v3icvSDMQdDp2kMhiO6tTxC0QCzan7QgJABRjMZBUOcJNiWMdHU9YEH/tmg+eYzcrT1GrZGB3/K+az2B55pbVPfTZ1M30HxTNL8mjc82EHyp21fkc06BYR5pMegu4LHZHgJLCc9IbxRB8A1NyyluML+8g35HevyNQ8AOuumc0dNPuhaVaF1A2r6heswK2xfERWJxg+nlLqAOzcffsLFz3qPjnAHVB4HaDiH4AuCmbpoWOIFU3GA+qTvTBegAGhNCMGhCL4QgGCVoSiB1uTctE0jTS12AM7lRp1R3bo3ccg/COo++Kcrln88ArpGefpJ70gYhG3VFTFFDUTGoaeAGVSyu0UwFg+u0LATr9Xpd39fI31zpu0aCIHz4EgoAUyhy5K9oAqCufAdLBbs+HDNygy9ID1nQW6v7zZTpBGcoMGwjHns//grAJwB/I0EwygWAHggCN2BFypSQu7++3jLtHM1LpIuGqasOYDomAH8jpYLWSK3LBYBhTgAkO+JwkfmIt1XnHbX1IQt0A6aEUh8MV1cdQAA+1u0TkguwIOwdFqp6IRA30LxEN7hBuqN2BIHfQ68AMFxRx4sAYCrwWqBzRKDqhUDktcEt0vMQ2HJ3QlcASn3QLXUAd94bVIH/COCvenuN5AKjagFqEASZkYLS2XVn7QLCcPUVgp9QBZ8AsBbweYFBtQA1CAKgBYL+g9Fdtbsg4HsWEJoaCsCf9Za1gM7YblxgKADACAhEmhbu0b69eh8EQAHBNRYATwMsBkelAWoUBB0TSHpXbb29eg4CoAkC8GPCwIANAeB/aLqADgm3SgPUKAiAMC1w+Oe3WPc7bG92IY3v/yPOI+hx8FVcX5FGAX8C+C8SBB8xURqgRkMAbEB4rr/U0YLCcCYtBwEbfx/4MUDweYDIARQAQvAX8qOB520AALaEQMQP8oDkCN4YVP3g2i7QBOGUYXD79/UamgIIwH+QAIhGA1vVAaqtIbC0ACQQvAHN4D9ZIwisIyB/d0ogqPMxlUYnhFgDqAP8iTQamKQOUG0NAZAtFD2ADsCjNcLwqv4dLSapY4ZhLVs9BtEpYS0C2Xw4OCkAwI4QAC0QHv3HiCF4sEYg+p6+ekwwaPAVAF0VxMk2HwayMQUoADsXgq6dIQDCQrHxY7QB+MeawuCPdo2KyyXDEAXf7T86G6jzADoX4GcHdy4EXZNAAGRBiKpghYBXN91Le4N0WppzDq0nedVaEgy54LP3q/1/RftkkAbfzwwyBUwOADAhBEAIQi4dKADeCANPUXMG0ieezup9H7KIXNuWlbp/VrV/XRCiADD47P2+bJw1wKQAABNDADRAWFuL3IAB/450kG4BvENz7aKemVQYdCZyH0Dowe/q+foZ79BeFMoU8FG2ujpI1wlOWgRGmhwCAF4sAt0HSSH4Jo0gMD2wVtDC0WHgVoGYSh70KPha+PFz6UU7viSMW+/9rfyPmQAAZoIAaIGQcwRNC7dIAPBKGoLgrqBrGX2K2s9T7ApDFPxnNIPP0Y1+Hu39viqYS8K4VJy5/zuS/W9GAJgRAGBGCIAGCPwArBO8YPJewytp3tXtCpUjqCswRXia8LoBGA/EOtg+Iw6+fgb/HPwsDPa1vOY1AryC+B6p92/yP1AdR8yoWSEA0gewOiFXKEb2SQjoCASBI4guGDRFANtBEFm+Bt9Tmv7/eqGOXrqnwaf1N6p/zNz7VbNDQGXSg/coHUPrAXQIuML5UpouaOk7jT1E/j+q7ecKW6Yzh0ADz6KPIyEGf1P8YY8AAMBqj+8FAH1PaGcQuXhVl7S/kabL3DU96EJXLR5XGAeC5n8HwOc4NP+zrvkq7Zv8jMHnPtz618D89u/aOwRUDYM2XY+gy9XY0193NF3tnBtODk0JXgdo1e8OQAB0eOuNP2fO157/BAFu38GnDgYB0HKFyBnYo30186VsHQD+btfytj5F6cpdwEHQrU986bS49/yD9H7VQSGgemBwd2C7sKZDx7mdQGFQKPiav+e9flHBpxYBARXAQCAYyHNpdImXaALiaxzVBfoAoLQmeEYKJIOqQDzY9x+lESIN/GKCTy0KAioDQ+QQdImo+TBxs3t0Sw8Ig/dkjUF+kq027/GLDD61SAgogQHIA6FO4duoFhgDgbqBTxT597KBB5YZfGrREKh6gCAUulUH6At8Tl4frIPXUav+6EgO7tFAoAqA4HYVfD2FNLj+WrdHE3jVUULgykCR+3qs/AAddcAjnQQEORkcO+lUAh7ppCEoGqb/AzCbVAEhdHzMAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.74,24.26a55.49,55.49,0,1,0,0,78.48,55.48,55.48,0,0,0,0-78.48Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 25,
    y: 24.71,
    width: 44.04,
    height: 76.49,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 42.37,
    y: 27.88,
    width: 9.22,
    height: 1.94,
    rx: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 53.96,
    cy: 28.85,
    r: 0.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 40.08,
    cy: 28.85,
    r: 0.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32.47,32.69H61.54a4.17,4.17,0,0,1,4.17,4.17V93.59A4.41,4.41,0,0,1,61.3,98h-29a4.22,4.22,0,0,1-4.22-4.22V37.06A4.37,4.37,0,0,1,32.47,32.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M70.25,59.27h35.83A2.92,2.92,0,0,1,109,62.19V91.28a2.92,2.92,0,0,1-2.92,2.92H70.25a0,0,0,0,1,0,0V59.27a0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 70.25,
    y: 75.22,
    width: 32.04,
    height: 4.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 70.25,
    y: 82.68,
    width: 38.75,
    height: 5.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 86.77,
    y: 63.03,
    width: 15.52,
    height: 9.22,
    rx: 1.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 75.49,
    y1: 63.57,
    x2: 83.7,
    y2: 63.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 75.49,
    y1: 65.35,
    x2: 83.7,
    y2: 65.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 75.49,
    y1: 67.13,
    x2: 83.7,
    y2: 67.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 75.49,
    y1: 68.91,
    x2: 83.7,
    y2: 68.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 75.49,
    y1: 70.48,
    x2: 83.7,
    y2: 70.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 75.49,
    y1: 72.26,
    x2: 83.7,
    y2: 72.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 70.25,
    y: 32.47,
    width: 30.8,
    height: 22.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 70.25,
    y: 33.45,
    width: 29.85,
    height: 20.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.38,36.42H76v2.67l5.32,0a4.42,4.42,0,0,1,.11.53,2.25,2.25,0,0,1-.8,2.44,3.38,3.38,0,0,0-.63-.5l-.07,0-.08,0a2.36,2.36,0,0,0-2.43.27,2,2,0,0,0-.53,1.88v.07l0,.07a11.29,11.29,0,0,0,1.9,2.75,41.46,41.46,0,0,0,4.73,4.51l.41.33,2-2L85.43,49a30.75,30.75,0,0,1-4.25-3.89A7,7,0,0,0,82.9,44a3.69,3.69,0,0,1,.79.21A3.54,3.54,0,0,0,85.31,47l0,0,0,0a5.13,5.13,0,0,0,4,0l.56-.21L89,44.42l-.55.19c-1.56.55-1.87,0-2-.36a1.13,1.13,0,0,1,.17-.93A1.64,1.64,0,0,1,88,43c1,.14,2,1.2,3.18,3.31l.29.52,2.33-1.25-.23-.51a10.08,10.08,0,0,0-2.8-3.67l0,0a5.29,5.29,0,0,0-3.94-1,3.86,3.86,0,0,0-2.2,1.18l-.27-.09a5.11,5.11,0,0,0,0-2.4l10.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.49,55.36c-6.59-.19-11.59,4.8-11.8,5l1.52,1.5s4.58-4.54,10.23-4.38c3.27.1,6.32,1.73,9.09,4.86l1.6-1.41C55,57.34,51.37,55.47,47.49,55.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.59,60c-4.51-.27-8.14,3.3-8.29,3.45l1.51,1.51s3.12-3,6.66-2.82a7.21,7.21,0,0,1,5.2,3.13l1.68-1.33A9.28,9.28,0,0,0,47.59,60Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.47,64c-2.75-.29-5.09,1.92-5.19,2l1.48,1.54s1.74-1.63,3.5-1.44a3.31,3.31,0,0,1,2.32,1.64l1.76-1.21A5.29,5.29,0,0,0,47.47,64Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethod);
export default __webpack_public_path__ + "static/media/payment_method.e6c5e1da5f8d1cb2f0b028353662bd10.svg";
export { ForwardRef as ReactComponent };